module.exports = __webpack_public_path__ + "img/result_tips.2d5e0b04.png";